import { Dialog } from "primereact/dialog";
import { JVInput } from "../../shared/JVInput";
import { Button } from "primereact/button";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { Fetch } from "../../shared/Fetch";
import { useEffect, useState } from "react";
import { IBlackListStatusMast } from "./Table";
import { JVDropdown } from "../../shared/JVDropdown";
import { IClientCompanyDropdown, IStatusDropdown, IVisaDropdown } from "../../models/IDropdown";
import { JVDate } from "../../shared/JVDate";
import { JVCheckbox } from "../../shared/JVCheckbox";
import { JVDropdownInput } from "../../shared/JVDropdownInput";
import { InputTextarea } from "primereact/inputtextarea";

interface IProps {
    singleData: IBlackListStatusMast,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

// interface IBlackListStatusForm {
//     blacklist_ID?: number,
//     blackList_Status_ID?: number,
//     vendor_Company_ID?: number | any,
//     blackList_Date?: Date,
//     status_Period?: boolean,
//     updated_By?: number,
//     updated_At?: Date,
//     createdBy?: number,
//     createdAt?: Date,
//     reason?: string,
// }

const schema = yup.object({
    vendor_Company_ID: yup.object().shape({
        vendor_Company_ID: yup.number(),
        vendor_Company_Name: yup.string()
    }),
    status_Period: yup.boolean().nullable(),
    blackList_Date: yup.date().when('status_Period', val => {
        return (val === false) ?
            yup.date().required("Till date is required") :
            yup.date().nullable();
    }),
    
        reason: yup.string()
            .min(10, "Minimum 10 characters required")
            .max(2500, "Maximum 2500 characters allowed"),
    // reason: yup.string().required("Reason is required"),

});

export const Form = (props: IProps) => {
    const [saveDis, setSaveDis] = useState(false);
    const [status, setStatus] = useState<Array<IStatusDropdown>>();
    const [blacklistDate, setBlacklistDate] = useState(false);
    const [clientCompanies, setClientCompanies] = useState<Array<IClientCompanyDropdown>>();
    // const [selectedStatus, setSelectedStatus] = useState<Array<IStatusDropdown>>();
    const [reasonValue, setReasonValue] = useState<string>("");

    const { control, handleSubmit, watch, formState: { errors }, reset, setValue } = useForm<IBlackListStatusMast>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    const onSubmit = (data: IBlackListStatusMast) => {
        // if ( (reasonValue === "" || reasonValue.length >= 500)) props.toast.current.show({ severity: 'error', content: "Please Enter enter less than 500 word." })

        setSaveDis(true);
        saveToDB(data);
    }

    const saveToDB = async (body: IBlackListStatusMast) => {

        const method = props.singleData.vendor_Company_ID != null ? "PUT" : "POST";
        const message = props.singleData.vendor_Company_ID != null ? "Updated Successfully" : "Added Successfully";
        let formData: any = body;
        formData.vendor_Company_ID = formData.vendor_Company_ID?.vendor_Company_ID;
        formData.blacklist_Status_ID = formData.blacklisted_Status?.blacklist_Status_ID;
        // formData.reason = reasonValue;
        if (formData.status_Period === true) {
            formData.blackList_Date = null;
        };
        delete formData.client_company;
        delete formData.blacklisted_Status;
        const response = await Fetch("BlackList_Mast", method, formData, null, props.toast);
        if (response) {
            props.hideDialog();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.setReload(!props.reload);
            setSaveDis(false);
        } else {
            setSaveDis(false);
        }
    }

    const loadStatus = async () => {
        const response = await Fetch("Dropdown/blacklistStatus", "GET", null, null, null);
        if (response) {
            const data: Array<IStatusDropdown> = await response.json();
            setStatus(data);
        }
    }

    const loadClientCompanies = async (name: string | null) => {
        const response = await Fetch("Dropdown/blacklist_vendor_companies", "GET", null, `filter=${name}`, null);
        if (response) {
            const data: Array<IClientCompanyDropdown> = await response.json();
            setClientCompanies(data);
            if (props.singleData.vendor_Company_ID) {
                setValue("vendor_Company_ID", {
                    vendor_Company_ID: data[0].vendor_Company_ID,
                    vendor_Company_Name: data[0].vendor_Company_Name,
                    website_URL: data[0].website_URL,
                });
            }
        }

    }

    const onHide = () => {
        setBlacklistDate(false);
        setReasonValue("");

        props.hideDialog();
    }


    useEffect(() => {
        const subscription = watch((value, { name, type }) => {

            if (name === "status_Period") {
                if (value.status_Period === true) {
                    setBlacklistDate(true)
                } else {
                    setBlacklistDate(false);
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);




    useEffect(() => {
        reset(props.singleData);
        if (props.singleData.blacklist_ID) {
            loadClientCompanies(props?.singleData?.vendor_Company_Name?.trim() || "");
            if (props?.singleData?.status_Period === true) {
                setBlacklistDate(true);
            };

            if (props?.singleData?.blackList_Date) {
                setValue("blackList_Date", new Date(props.singleData.blackList_Date));
            };
        }
    }, [props.open]);

    useEffect(() => {
        loadStatus();
    }, []);

    const completeMethodClientCompanies = (event: { query: string }) => {
        loadClientCompanies(event.query);
    }


    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit BlackList Status" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVDropdownInput column={2} completeMethod={completeMethodClientCompanies} label="Company Name" control={control} name="vendor_Company_ID" options={clientCompanies} optionLabel="vendor_Company_Name" placeholder="Search Client/Company" />
                <div className="field col-12 md:col-6">
                    <p style={{ color: 'white' }}>.</p>
                    <JVCheckbox label="Status Period" control={control} name="status_Period" />
                </div>
                {!blacklistDate && <JVDate label="BlackList Date" control={control} name="blackList_Date" />}
                <JVDropdown column={3} label="BlackList Status" control={control} name="blackList_Status_ID" options={status} optionLabel="blacklist_Status" optionValue="blacklist_Status_ID" placeholder="Select Status" />
                <JVInput label="Reason" control={control} name="reason" error={errors.reason?.message} />
                {/* <InputTextarea value={reasonValue} onChange={(e) => setReasonValue(e.target.value)} rows={10} cols={20} placeholder="Enter Comment" />
                {reasonValue?.length <= 9 && <small className="p-error" >Minimum 10 Characters Required*</small>} */}
                {/* <div className="col-12 md:col-12 flex gap-4">
                    <Button className="field col md:col" label="SAVE" type="submit" disabled={saveDis}></Button>
                    <Button className="field col md:col p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                </div> */}
                   <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="SAVE" type="submit"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined"></Button>
                </div>

            </form>
        </Dialog>
    );
}